import "./src/styles/reset.scss"
import React from "react"
import { WrapWithI18nProvider } from "./src/i18n/wrapWithI18nProvider"
import { isLogRocketEnabled, LogRocketLibraryMinJs } from "./log-rocket"

export const wrapPageElement = (node, pluginOptions) => (
  <WrapWithI18nProvider {...node} {...pluginOptions} />
)

export const onClientEntry = () => {
  if (isLogRocketEnabled()) {
    document.head.appendChild(LogRocketLibraryMinJs)
  }
}

export const onRouteUpdate = () => {
  if (
    process.env.NODE_ENV === "production" &&
    typeof window.fbq === "function"
  ) {
    window.fbq("track", "ViewContent")
  }
}

export const shouldUpdateScroll = () => {
  const hash = window.location.hash.substring(1)
  return !!hash
}
